<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '20px' }">
      <template #title>
        <!-- <span>: {{ getUrlPath }}</span> -->
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12">
            <h5 class="font-semibold m-0">
             <a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>
              Alumni Form</h5>
          </a-col>
          <a-col :span="24" :md="12" class="text-right">
            <a-button type="primary" size="small" @click="actionDialog">
              <a-icon type="file-pdf" class="mr-5" /> Save to pdf
            </a-button>
          </a-col>
        </a-row>
      </template>

      <div class="card-container">
        <a-tabs type="card" @change="callData">
          <a-tab-pane v-for="(item, index) in panes" :tab="item.name" :key="'tabs' + parseInt(index + 1)">
            <a-spin :spinning="loadingMain" tip="Loading...">
              <component id="tabAlumni" :is="item.component" :dataProfile="dataProfile" @updateData="updateData"
                @updateObjMainProfile="updateObjMainProfile" @errorNotification="errorNotification"
                @successNotification="successNotification" @updateMainContact="updateMainContact" />
            </a-spin>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>

    <!-- modal print -->
    <a-modal title="Confirm" :visible="dialogPrint" @ok="printAlumniProfile" @cancel="actionDialog">
      <!-- footer -->
      <template slot="footer">
        <a-button key="back" type="danger" @click="actionDialog">
          Close pop-up
        </a-button>
        <a-button key="submit" type="primary" :disabled="loadingPrint" @click="printAlumniProfile">
          Create pdf
        </a-button>
      </template>
      <!-- footer -->
      <p class="mt-10 mb-10">
        Select the section for which you want to generate the pdf.
      </p>
      <!-- select -->
      <a-spin :spinning="loadingPrint" tip="Please wait for the system to generate pdf....">
        <div class="spin-content">
          <div class="mt-5 mb-10">
            <a-checkbox :checked="checkAll" @change="onCheckAllChange">
              Check all
            </a-checkbox>
          </div>
          <hr />
          <a-checkbox-group v-model="checkedList" @change="onChange">
            <div v-for="(op, index) in optionPrint" :key="'op' + index">
              <a-checkbox :value="op"> {{ op }} </a-checkbox>
            </div>
          </a-checkbox-group>
        </div>
      </a-spin>
    </a-modal>
    <!-- component -->
    <vue-html2pdf v-if="dataProfile.length != 0" :show-layout="false" :float-layout="true" :enable-download="false"
      :preview-modal="true" :paginate-elements-by-height="1400" filename="alumni_profile" :pdf-quality="2"
      :manual-pagination="false" pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px" ref="html2Pdf">
      <section slot="pdf-content">
        <span v-for="(page, index) in checkedList" :key="'print' + index">
          <alumniPdf :pageTitle="`${page}`" :dataProfile="dataProfile" :dataAchievment="dataAchievment" :dataEngagement="dataEngagement"/>
          <div class="html2pdf__page-break" />
        </span>
      </section>
    </vue-html2pdf>
    <!-- component -->
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import alumniPdf from "./genPdf/alumni_pdf.vue";
//
import MainProfile from "./main.vue";
import background from "./background.vue";
import contact from "./contact.vue";
import FutherEducation from "./FutherEducation.vue";
import WorkExperience from "./WorkExperience.vue";
import achievements from "./Achievements.vue";
import Engagements from "./Engagements.vue";

const optionPrint = [
  "Main",
  "Background",
  "Contact",
  "Futher Education",
  "Work Experience",
  "Achievements",
  "Engagements"
];
export default {
  components: {
    VueHtml2pdf,
    alumniPdf,
    MainProfile,
    background,
    contact,
    FutherEducation,
    WorkExperience,
    achievements,
    Engagements
  },
  data() {
    return {
      loadingMain: false,
      dataProfile: [],
      dataMainContact: [],
      panes: [
        {
          name: "Main",
          component: "main-profile",
        },
        {
          name: "Background",
          component: "background",
        },
        { name: "Contact", component: "contact" },
        { name: "Futher Education", component: "futher-education" },
        { name: "Work Experience", component: "work-experience" },
        { name: "Achievements", component: "achievements" },
        { name: "Engagement", component: "engagements" },
      ],
      // print
      loadingPrint: false,
      optionPrint,
      dataAchievment: [],
      dataEngagement: [],
      dialogPrint: false,
      indeterminate: true,
      checkAll: false,
      checkedList: ["Main"],
    };
  },
  computed: {
    getUrlPath() {
      return this.$route.query.id;
    },
  },
  mounted() {
    this.getProfileMain();
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/alumni",
        })
        .catch((err) => { });
    },
    callData(key) {
      switch (key) {
        case "tabs1":
          // statements
          this.getProfileMain();
          break;
        case "tabs2":
          // statements
          break;
        case "tabs3":
          // statements
          break;
        case "tabs4":
          // statements
          break;
        case "tabs5":
          // statements,
          break;
        case "tabs6":
          // statements
          break;
        default:
        // statements
      }
    },
    async getProfileMain() {
      this.loadingMain = true;
      this.dataProfile = [];
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-profile/${this.$route.query.id}/`
        );
        if (res.status === 200) {
          this.dataProfile.push(res.data);
          this.dataAchievment = await this.getArchievements(res.data.student_id)
          this.dataEngagement = await this.getEngagements(res.data.student_id)
          this.loadingMain = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.dataProfile = [];
        this.notificationDialog(
          "#ff1919",
          "#ffffff",
          `Error ${error.response.status}`,
          `Problem issue connect api : /student_affair/alumni-profile/`
        );
        this.loadingMain = false;
      }
    },
    updateData(...args) {
      let file_img = args[0].data.file_img;
      this.dataProfile[0] = {
        ...this.dataProfile[0],
        file_img,
      };
      let arrSlotUp = [];
      arrSlotUp.push(this.dataProfile[0]);
      this.dataProfile.splice(0, 1, arrSlotUp[0]);
    },
    updateObjMainProfile(...args) {
      this.dataProfile.splice(0, 1, args[0].data);
    },
    updateMainContact(...args) {
      // //console.log(args[0].dataIdDelMain)
      const indexDetail = this.dataProfile.contact_detail.findIndex(
        (itemA) => itemA.id === args[0].dataIdDelMain
      );
      const indexID = this.dataProfile.alumin_contact.findIndex(
        (itemB) => itemB === args[0].dataIdDelMain
      );
      this.dataProfile.contact_detail.splice(indexDetail, 1);
      this.dataProfile.alumin_contact.splice(indexID, 1);
    },
    // notification
    errorNotification(...args) {
      this.notificationDialog(
        "error",
        `Failed to connect to the API`,
        `Error ${error.response.status} : ${args[0].UrlPath}`
      );
    },
    successNotification(...args) {
      this.notificationDialog("success", args[0].msg, args[0].des);
    },
    notificationDialog(typeDialog, Msg, description) {
      this.$notification[typeDialog]({
        message: function (h) {
          return h("div", [
            h("strong", { class: "" }, Msg),
          ]);
        },
        description: description,
      });
    },
    // print html
    onChange(checkedList) { },
    onCheckAllChange(e) {
      // //console.log(e)
      if (this.checkedList.length > 1) {
        this.checkedList = ["Main"];
        this.checkAll = false;
      } else {
        this.checkAll = true;
        this.checkedList = e.target.checked ? optionPrint : [];
      }
    },
    async printAchievment(id) {
      this.dataAchievment = [];
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-award/?alumni_profile__student_id=${id}`
        );
        if (res.status === 200) {
          this.dataAchievment = res.data.map((item) => ({ ...item }));
        } else {
          throw res;
        }
      } catch (error) {
        this.notificationDialog(
          "#ff1919",
          "#ffffff",
          `Error ${args[0].errorMsg}`,
          `Problem issue connect api`
        );
      }
    },
    getEngagements(studentID) {
      return new Promise((resolve) => {
        this.$http
          .get(
            "/student_affair/engagement-record/?search="+studentID)
          .then((response) => {
            if (response.status == 200 & response.data.length > 0) {
              resolve(response.data);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve([]);
          });
      });
    },
    getArchievements(studentID) {
      return new Promise((resolve) => {
        this.$http
          .get(
            "/student_affair/alumni-award/?alumni_profile__student_id=" + studentID)
          .then((response) => {
            if (response.status == 200 & response.data.length > 0) {
              resolve(response.data);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve([]);
          });
      });
    },
    actionDialog() {
      this.dialogPrint = !this.dialogPrint;
      this.loadingPrint = false;
      this.checkedList = ["Main"];
      this.checkAll = false;
    },
    async printAlumniProfile() {
      // Pass the element id here
      // await this.$htmlToPaper("printMe");
      this.loadingPrint = true;
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf();
        this.loadingPrint = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}
</style>

